'use client'

import { io, type Socket } from 'socket.io-client'

const API_BASE = process.env.NEXT_PUBLIC_API_URL || 'https://app.canerozen.com/api'
const SOCKET_BASE = API_BASE.endsWith('/api') ? API_BASE.slice(0, -4) : API_BASE

let __socket: Socket | null = null
let __socketToken: string | null = null

export function getSocket(token: string): Socket {
  // Reuse the existing instance for the same token.
  // Even if it's currently disconnected, socket.io will handle reconnection.
  if (__socket && __socketToken === token) return __socket

  if (__socket) {
    try {
      __socket.disconnect()
    } catch {
      // ignore
    }
    __socket = null
  }

  __socketToken = token
  __socket = io(SOCKET_BASE, {
    // Prefer WebSocket, but allow polling fallback when the backend domain's
    // reverse proxy/LB doesn't support WebSocket upgrade.
    // IMPORTANT: start with polling, then upgrade to websocket when available.
    // If websocket is listed first and the proxy blocks Upgrade, the client may
    // fail fast and never reach the polling fallback.
    transports: ['polling', 'websocket'],
    timeout: 10000,
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 400,
    reconnectionDelayMax: 2500,
  })

  // Optional diagnostics (enable by setting localStorage.debug_socket = '1')
  try {
    if (typeof window !== 'undefined' && localStorage.getItem('debug_socket') === '1') {
      const s = __socket
      s.on('connect', () => {
        console.log('[socket] connect', s.id, 'transport=', (s.io as any)?.engine?.transport?.name)
      })
      s.on('disconnect', (reason) => {
        console.log('[socket] disconnect', reason)
      })
      s.on('connect_error', (err) => {
        console.log('[socket] connect_error', err?.message || err)
      })
      ;(s.io as any)?.engine?.on?.('upgrade', (transport: any) => {
        console.log('[socket] upgrade ->', transport?.name)
      })
    }
  } catch {
    // ignore
  }

  return __socket
}

export function disconnectSocket() {
  if (!__socket) return
  try {
    __socket.disconnect()
  } catch {
    // ignore
  }
  __socket = null
  __socketToken = null
}
